module.exports = __webpack_public_path__ + "static/media/List_DRUM.4d03f014.mp3";